import { Card } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import AreaRelatorioEstado from "@/modules/relatorio/components/graphics-nivo/AreaBarRelatorioEstado";
import { TRelatorioContext } from "../RelatorioLayout";

const EstadosTab = () => {
  const { empresasPorEstado, loadingEstados, errorEstados } = useOutletContext<TRelatorioContext>();

  return (
    <Card>
      <AreaRelatorioEstado empresasPorEstado={empresasPorEstado} loading={loadingEstados} error={errorEstados} />
    </Card>
  );
};

export default EstadosTab;
